const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOptionEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 39,
    width: 39,
    height: 39,
    rx: 19.5,
    transform: "rotate(-180 39 39)",
    fill: "#FFBA34",
    style: {
      fill: "#FFBA34",
      fill: "color(display-p3 1.0000 0.7296 0.2045)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19.5003C11.9996 19.6437 12.0404 19.7843 12.1175 19.9052C12.1946 20.0262 12.3048 20.1225 12.435 20.1828L18.885 23.1153C19.0794 23.2033 19.2903 23.2488 19.5038 23.2488C19.7172 23.2488 19.9281 23.2033 20.1225 23.1153L26.5575 20.1903C26.6903 20.1306 26.8028 20.0336 26.8814 19.9111C26.9599 19.7885 27.0012 19.6458 27 19.5003M12 23.2503C11.9996 23.3937 12.0404 23.5343 12.1175 23.6552C12.1946 23.7762 12.3048 23.8725 12.435 23.9328L18.885 26.8653C19.0794 26.9533 19.2903 26.9988 19.5038 26.9988C19.7172 26.9988 19.9281 26.9533 20.1225 26.8653L26.5575 23.9403C26.6903 23.8806 26.8028 23.7836 26.8814 23.6611C26.9599 23.5385 27.0012 23.3958 27 23.2503M20.1225 12.1353C19.9271 12.0461 19.7148 12 19.5 12C19.2852 12 19.0729 12.0461 18.8775 12.1353L12.45 15.0603C12.3169 15.119 12.2038 15.2151 12.1243 15.3369C12.0449 15.4588 12.0026 15.6011 12.0026 15.7465C12.0026 15.892 12.0449 16.0343 12.1243 16.1561C12.2038 16.278 12.3169 16.3741 12.45 16.4328L18.885 19.3653C19.0804 19.4544 19.2927 19.5005 19.5075 19.5005C19.7223 19.5005 19.9346 19.4544 20.13 19.3653L26.565 16.4403C26.6981 16.3816 26.8112 16.2855 26.8907 16.1636C26.9701 16.0418 27.0124 15.8995 27.0124 15.754C27.0124 15.6086 26.9701 15.4663 26.8907 15.3444C26.8112 15.2226 26.6981 15.1265 26.565 15.0678L20.1225 12.1353Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionEdit);
export default __webpack_public_path__ + "static/media/option_edit.e5e2cab8a14c38014533f9e26dac9c10.svg";
export { ForwardRef as ReactComponent };